module.exports = __webpack_public_path__ + "static/img/indexIntroArea02.630a261.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/image/content/indexIntroArea02.jpg
// module id = ojU/
// module chunks = 3